import { useLanguage } from '../contexts/LanguageContext';

/**
 * Hook to generate localized paths with language prefix
 * @returns {Function} Function that takes a path and returns it with language prefix
 */
export const useLocalizedPath = () => {
  const { currentLanguage } = useLanguage();

  return (path) => {
    // Remove leading slash if present
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;
    // Return path with language prefix
    return `/${currentLanguage}/${cleanPath}`;
  };
};
